import DictionaryLetterList from './DictionaryLetterList';

export default DictionaryLetterList;
